<app-base-post
  [post]="post"
  [isLoading]="isLoading"
  [hideFeaturedImage]="true"
></app-base-post>
